import { ChevronLeft, ChevronRight } from 'lucide-react';
import ReactPaginate from 'react-paginate';

interface PaginationProps {
  currentPage: number; // zero-based
  totalPages: number;
  onPageChange: (value: React.SetStateAction<number>) => void;
  perPage: number;
  totalItems: number;
  onPerPageChange?: (size: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  perPage,
  totalItems,
  onPerPageChange,
}: PaginationProps) {

  return (
    <div className="flex  items-center justify-center py-3   rounded-lg  shadow">
      {/* Pagination buttons */}
      <div className="flex items-center w-full  lg:w-fit justify-center space-x-1">
        <ReactPaginate
          pageCount={totalPages}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          onPageChange={({ selected }) => onPageChange(selected)}
          previousLabel={<ChevronLeft size={14} />}
          nextLabel={<ChevronRight size={14} />}
          containerClassName="flex items-center text-gray-700 dark:text-slate-200 "
          pageClassName="w-8 h-7 flex items-center justify-center rounded hover:bg-accent-400 hover:text-white"
          pageLinkClassName="w-full h-full flex items-center justify-center"
          previousClassName="w-8 h-7 mr-1 text-white flex bg-accent-500/95 items-center justify-center rounded hover:bg-500 disabled:opacity-50 disabled:cursor-not-allowed"
          previousLinkClassName="w-full h-full flex items-center justify-center"
          nextClassName="w-8 h-7 ml-1 flex text-white bg-accent-500/95 items-center justify-center rounded hover:bg-500 disabled:opacity-50 disabled:cursor-not-allowed"
          nextLinkClassName="w-full h-full flex items-center justify-center"
          breakClassName="px-0"
          activeClassName="bg-accent-500 text-white hover:bg-accent-500/95"
          disabledClassName="opacity-50 cursor-not-allowed"
        />

      </div>

    </div>
  );
}
